export const Order = {
  LeftRight: 'left to right',
  RightLeft: 'right to left',
  TopBottom: 'top to bottom',
  BottonTop: 'bottom to top'
};
